import * as React from "react";
export var colorStatus = function colorStatus(claimStatus) {
  switch (claimStatus) {
    case "denounced":
      return /*#__PURE__*/React.createElement("a", null, "\uD83D\uDFE1 ");

    case "settlement":
      return /*#__PURE__*/React.createElement("a", null, "\uD83D\uDFE2 ");

    case "closed compensation":
      return /*#__PURE__*/React.createElement("a", null, "\uD83D\uDD34 ");

    case "closed no compensation":
      return /*#__PURE__*/React.createElement("a", null, "\uD83D\uDD34 ");

    case "closed no records":
      return /*#__PURE__*/React.createElement("a", null, "\uD83D\uDD34 ");

    case "dismissed by customers":
      return /*#__PURE__*/React.createElement("a", null, "\uD83D\uDD34 ");

    default:
      return null;
  }
};